import React from 'react'

function Headerpage() {
    return (
        <div className='container' style={{ width: "50%" }}>
            <h1 className='text-center'>Service Performance Report</h1>
            <br />
            <table className='text-left table table-bordered' cellPadding={5}>
                <tbody>
                    <tr>
                        <td className=''>
                            <b>Document Code:</b>
                        </td>
                        <td className=''>ALL-SPR-V1</td>
                    </tr>
                    <tr>
                        <td className=''>
                            <b>Document Name:</b>
                        </td>
                        <td className='border-1'>Service Performance Report</td>
                    </tr>
                    <tr>
                        <td className=''>
                            <b>Version:</b>
                        </td>
                        <td className=''>V.1</td>
                    </tr>
                    <tr>
                        <td className=''>
                            <b>Date of version:</b>
                        </td>
                        <td className=''>18 September 2022</td>
                    </tr>
                    <tr>
                        <td className=''>
                            <b>Create by:</b>
                        </td>
                        <td className=''>Kritsana Kreemontree</td>
                    </tr>
                    <tr>
                        <td className=''>
                            <b>Approve by:</b>
                        </td>
                        <td className=''>Benjawan Intara</td>
                    </tr>
                    <tr>
                        <td className=''>
                            <b>Confidentiality level:</b>
                        </td>
                        <td className=''>Medium</td>
                    </tr>
                </tbody>
            </table>
            <br />
        </div>
    )
}

export default Headerpage